import React, { useState } from 'react';
import PropTypes from 'prop-types';

import I18n from 'utils/I18n';
import BaseModal from '../BaseModal';

import styles from './styles.scss';

const CaptionEditModal = ({
  isOpen,
  isSaving,
  onDismiss,
  onSubmit,
  caption,
  onTextChange,
  title
}) => {
  const [updatedCaption, setUpdatedCaption] = useState(caption);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  const handleTextChange = (e) => {
    const captionText = e.target.value;
    setUpdatedCaption(captionText);
    onTextChange(captionText);
  };

  return (
    <BaseModal
      isOpen={isOpen}
      hasChanges={updatedCaption !== caption}
      isSaving={isSaving}
      buttonLabels={{
        savingText: I18n.t('templates.feed.activity.edit_caption.saving'),
        saveText: I18n.t('templates.feed.activity.edit_caption.save')
      }}
      onDismiss={onDismiss}
      onSubmit={handleSubmit}
      title={title}
    >
      <textarea
        className={styles.textArea}
        id="caption"
        name="caption"
        disabled={isSaving}
        defaultValue={caption}
        onChange={handleTextChange}
      />
    </BaseModal>
  );
};

CaptionEditModal.propTypes = {
  isOpen: PropTypes.bool,
  onDismiss: PropTypes.func,
  onSubmit: PropTypes.func,
  isSaving: PropTypes.bool,
  caption: PropTypes.string,
  onTextChange: PropTypes.func,
  title: PropTypes.string.isRequired
};

CaptionEditModal.defaultProps = {
  isOpen: false,
  onDismiss: () => {},
  onSubmit: () => {},
  isSaving: false,
  onTextChange: () => {},
  caption: null
};

export default CaptionEditModal;
